export const REASON_ERROR = [
    {
        name : "Sọc đầu phun",
        type_error : 'print'
    },
    {
        name : "Cạt phôi",
        type_error : 'print'
    },
    {
        name : "Bẩn mực",
        type_error : 'print'
    },
    {
        name : "Mất màu",
        type_error : 'print'
    },
    {
        name : "Bẩn do máy ép",
        type_error : 'press'
    },
    {
        name : "Gập, nhăn",
        type_error : 'press'
    },
    {
        name : "Sai, nhạt màu",
        type_error : 'press'
    },
    {
        name : "Nháy hình",
        type_error : 'press'
    },
    {
        name : "Dính bụi, chỉ",
        type_error : 'fabric'
    },
    {
        name : "Bẩn vải",
        type_error : 'fabric'
    },
    {
        name : "Dệt vải",
        type_error : 'fabric'
    },
    {
        name : "Mốc vải",
        type_error : 'fabric'
    },
    {
        name : "Rách vải",
        type_error : 'fabric'
    },
    {
        name : "SW cắt sai chi tiết",
        type_error : 'other'
    },
    {
        name : "QCSE tích sai chi tiết",
        type_error : 'other'
    },
    {
        name : "Cắt hỏng mảnh bù",
        type_error : 'other'
    },
    {
        name : "Không xác định",
        type_error : 'unknown'
    },
]